// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"67b41861","761":"d031bb4b"}[chunkId] + ".chunk.js";
};